export default "__VITE_ASSET__CudCi6Ri__"